import {
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

/**
 * Single source of truth for every floating surface in the app, dropdown /
 * select menus, context menus, tooltips, popovers and custom panels. The
 * "frosted dark panel" look: dark translucent fill, blur, a subtle light
 * border and rounded corners.
 *
 * - MUI surfaces: spread this into the relevant `sx` selector
 *   (`.MuiAutocomplete-paper`, `.MuiTooltip-tooltip`, `.MuiDataGrid-paper`, …).
 * - Plain `<div>` panels: use the `FloatingSurface` component or the
 *   `floating-surface` SCSS mixin (kept in sync in `helpers/surfaces.scss`).
 */
export const floatingSurface = {
  backgroundColor: transparentColors.blackShade5,
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  border: `2px solid ${whiteShades.shade1}`,
  borderRadius: '0.5rem',
  color: primaryColors.white,
  boxShadow: 'none'
}
